<template>
        <div class='waktu-sholat'>
            <div id='list-waktu'>
                <div v-bind:class="{'loader-waktu': status, hideLoader: status2}">
                    <button class='btn-loader' type='button'></button>
                </div>
                <div class='box-waktu'>

                    <div class="isi-waktu">
                        <div id='nomor'>
                            <button type='button' class="btn-nomor">1</button>
                        </div>
                        <div id='nama'>
                            <span>Subuh</span>
                        </div>
                        <div id='times'>
                            <span>{{this.Subuh}}</span>
                        </div>
                    </div>
                    <div class="isi-waktu">
                        <div id='nomor'>
                            <button type='button' class="btn-nomor">2</button>
                        </div>
                        <div id='nama'>
                            <span>Dzuhur</span>
                        </div>
                        <div id='times'>
                            <span>{{ this.Dzuhur }}</span>
                        </div>
                    </div>
                    <div class="isi-waktu">
                        <div id='nomor'>
                            <button type='button' class="btn-nomor">3</button>
                        </div>
                        <div id='nama'>
                            <span>Ashar</span>
                        </div>
                        <div id='times'>
                            <span>{{ this.Ashar }}</span>
                        </div>
                    </div>
                    <div class="isi-waktu">
                        <div id='nomor'>
                            <button type='button' class="btn-nomor">4</button>
                        </div>
                        <div id='nama'>
                            <span>Maghrib</span>
                        </div>
                        <div id='times'>
                            <span>{{ this.Maghrib }}</span>
                        </div>
                    </div>
                    <div class="isi-waktu">
                        <div id='nomor'>
                            <button type='button' class="btn-nomor">5</button>
                        </div>
                        <div id='nama'>
                            <span>Isa</span>
                        </div>
                        <div id='times'>
                            <span>{{ this.Isa }}</span>
                        </div>
                    </div>

                </div>
                <div class='box-waktu' id='daerah'>
                    <div class="konten-daerah">
                        <img src="../../assets/gambar/lokasi.png"/>
                        <h3>{{Lokasi2}}</h3>
                        <p>{{lokasi}}</p>
                        <!-- metode -->
                        <div class='metode'>
                            <label for='.metode'>Metode</label>
                            <br/>
                            <small v-for="(result,i) in metode" v-bind:key="i">{{result}}</small>
                        </div>
                        <!-- akhir metode -->
                    </div>
                </div>
                <!-- button close -->
                <button @click="handlingClose()" class="btn-close" type='button'><i class='fa fa-times'></i></button>
                <!-- akhir button close -->
            </div>
        </div>
</template>

<style scoped>
.waktu-sholat 
{
    width: 100%;
    height: 100%;
    top: -200%;
    left: 0;
    right: 0;
    bottom : 0;
    position: fixed;
    z-index: 5000;
    background-color: rgba(0,0,0,0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s;
}
.show-waktu{
    top: 0;
    transition: 0.5s;
}
#list-waktu 
{
    width: 70%;
    height: auto;
    padding: 2% 2% 2% 2%;
    background-color: white;
    border-radius: 5px;
    border: 1px solid transparent;
    display: flex;
    justify-content: space-between;
    position: relative;
}
.box-waktu 
{
    width: 50%;
}
.isi-waktu 
{
    width: 100%;
    display: flex;
    width: 100%;
    justify-content: space-between;
    border: 1px solid #ebebeb;
    border-radius: 50px;
    padding: 2% 4% 2% 4%;
    align-items: center;
    transition: 0.3s;
    margin-bottom: 5%;
}
#times 
{
    font-weight: bold;
}
.isi-waktu:hover{
    box-shadow: 0px 6px 20px 1px rgba(0,0,0,0.1);
    transform: scale(1.02);
    cursor: pointer;
}

.btn-nomor 
{
    width: 30px;
    height: 30px;
    border-radius: 50px;
    border: none;
    background-color: transparent;
    color: gray;
    font-weight: bold;
    border: 2px solid rgb(47, 255, 92);
}
.btn-nomor:focus{
    outline: none;
}
#daerah 
{
    display: flex;
    justify-content: center;
    align-items: center;
}
.konten-daerah 
{
    text-align: center;
}
.konten-daerah img 
{
    margin-bottom: 5%;
}
.konten-daerah h3{
    font-weight: bold;
}
.metode
{
    width: 100%;
    text-align: left;
    margin-top: 30%;
}
.metode label 
{
    font-weight: bold;
    font-size: 11px;
}
.metode small 
{
    display: block;

}
.btn-close 
{
    position: absolute;
    width: 30px;
    height: 30px;
    right: -1%;
    border-radius: 50px;
    border: 2px solid gray;
    background-color: white;
    color: gray;
    top: -3%;
}
.btn-close:focus{
    outline: none;
}
.loader-waktu 
{
    top: 0;
    left: 0;
    right: 0;
    bottom : 0;
    position: absolute;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-loader 
{
    width: 60px;
    height: 60px;
    border-radius: 50px;
    border: 3px solid transparent;
    border-left-color: rgb(47, 255, 82);
    background-color: transparent;
    animation: loading 1s linear infinite;
}
.btn-loader:focus{
    outline: none;
}
.hideLoader{
    display: none;
}
@keyframes loading {
    from 
    {
        transform: rotate(0deg);
    }to 
    {
        transform: rotate(360deg);
    }
}
@media screen and (max-width: 780px)
{
    #daerah
    {
        display: none;
    }
    .box-waktu
    {
        width: 100%;
    }
    #list-waktu 
    {
        width: 90%;
        padding-top: 6%;
        padding-bottom: 3%;
    }
    .btn-close
    {
        right: -3%;
    }
}
</style>
<script>
import { bus } from '../../main';
import axios from 'axios';
export default {
    props : ['times'],
    data(){
        return {
            Subuh: 'loading..',
            Dzuhur: 'loading..',
            Ashar : 'loading..',
            Maghrib: 'loading..',
            Isa: 'loading..',
            metode: [],
            status: true,
            status2: false,
            lokasi: '',
            Lokasi2: '',
            url: 'https://time.siswadi.com/geozone/',
            proxy: 'https://cors-anywhere.herokuapp.com/',
        }
    },
    methods: {
        handlingClose(){
            const popup = document.querySelector('.waktu-sholat');
            popup.classList.toggle('show-waktu');
            this.status2 = false;
            this.lokasi = '';
        }
    },
    mounted(){
        bus.$on('AddTimes', (param) => {

            this.Subuh = param.Subuh;
            this.Dzuhur = param.Dzuhur;
            this.Ashar = param.Ashar;
            this.Maghrib = param.Maghrib;
            this.Isa = param.Isa;
            this.metode = param.Metode;
            this.status2 = true;
            this.Lokasi2 = param.Lokasi2;
            axios.get(`${this.proxy}${this.url + this.Lokasi2}`)
            .then(res => {
                this.lokasi = res.data.data.address;
            })

        })
    }
}
</script>